import { mapGetters } from 'vuex';
import { CalculatorDialog } from '@/components/Calculator/CalculatorDialog';

export default {
  computed: {
    ...mapGetters({
      calculatorTheme: 'theme/getCalculator'
    })
  },
  methods: {
    showDisclaimerDialog() {
      this.$euiNotifications.emit({
        notification: CalculatorDialog,
        html: this.calculatorTheme?.disclaimerPopup || '',
        htmlClassName: 'disclaimerPopContent',
        htmlStyle: {
          padding: '20px'
        },
        qCardStyle: {
          padding: '0',
          width: '100%',
          maxWidth: '80vw',
          minHeight: '300px',
          display: 'flex',
          flexFlow: 'row wrap'
        },
        closeBtnStyle: {
          color: 'white'
        }
      });
    }
  }
};
